export default "__VITE_ASSET__UPQB3eJW__"